'use strict';

var chunkHL7FQXW2_js = require('./chunk-HL7FQXW2.js');

var t="api/v1/activity";function o(){let e={enableLoader:!0,enableSnackbar:!1};return chunkHL7FQXW2_js.a().get(t,e)}

exports.a = o;
